import { useEffect, useRef } from 'react';

import { subPageTitleElementRef, subPageTitleScrollProgress } from '../utils/scroll/subPageTitleScrollProgress';

const UNSET_SCROLL_PROGRESS = -1;

const useSubPageTitle = <T extends HTMLElement = HTMLElement>() => {
  const titleRef = useRef<T>(null);
  const rafId = useRef<number | null>(null);

  useEffect(() => {
    subPageTitleElementRef.current = titleRef.current;
    let prevProgress = UNSET_SCROLL_PROGRESS;

    const tick = () => {
      const progress = subPageTitleScrollProgress.current;
      const titleElement = titleRef.current;
      if (titleElement && progress !== prevProgress) {
        prevProgress = progress;
        titleElement.style.opacity = String(1 - progress);
      }
      rafId.current = requestAnimationFrame(tick);
    };

    rafId.current = requestAnimationFrame(tick);

    return () => {
      if (rafId.current !== null) {
        cancelAnimationFrame(rafId.current);
        rafId.current = null;
      }
      subPageTitleElementRef.current = null;
      subPageTitleScrollProgress.current = 0;
    };
  }, []);

  return titleRef;
};

export default useSubPageTitle;
